// extracted by mini-css-extract-plugin
export default {"Expandable":"MoreBlock_Expandable__FN3m0","Content":"MoreBlock_Content__DpzyH","Toggle":"MoreBlock_Toggle__vHNbA"};